<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :triggerSave.sync="triggerSave"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
import ApiRepository from "@/core/ApiRepository";

export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Visit List',to: '/admin/list-visit_list' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create A New Visit",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      active_check:true,
      users_clubs_id : '',
      time_zone_local : moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted () {
    console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    this.items_bread_crumb[1].label = this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_VISIT_LIST);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-visit_list' });
    },
    UpdateActive(key){
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if(key == 'lock'){
        this.active_check = false
      }else{
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': {'_eq': this.$route.params.id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        if(key == 'lock'){
          var query_t =  `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      // console.log("params",params)
      const code_visit_for_buy = await ApiRepository.post('/_api/car/generate_code_visit_for_buy');
      let objects = {
        name: params?.name ?? '',
        bond_fee: params?.bond_fee ?? 0,
        active: params?.active ?? true,
        updated_at: moment.tz(new Date(), this.time_zone_local),
        updated_by: this.$store.getters.user
      }
      this.triggerSave = false;
      objects.created_at = moment.tz(new Date(), this.time_zone_local);
      objects.created_by = this.$store.getters.user;
      if(this.mode == 'add'){
        await this.$apollo.mutate({
            mutation: DataServices.insertData('rental_order'),
            variables: {
              objects: {
                type_order: 2,
                code:code_visit_for_buy?.data?.data?.code ?? null,
                booking_status : 'BOOKING_BUY',
                car_status : 'FOR_SELL',
                ref_email : null,
                created_at: moment.tz(new Date(), this.time_zone_local),
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
                created_by: this.$store.getters.user,
                active: true, 
                deleted: false,
                uid : params?.user ?? null,
                source : 'WEB',
                showroom_id : params?.showroom_id ?? null,
                showroom_name : params?.showroom_name ?? null,  
                note : params?.note ?? null,
              }
            }
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
            var returning = res.data[Object.keys(res.data)].returning[0];
            await this.$apollo.mutate({
            mutation: DataServices.insertData('rental_order_buy'),
            variables: {
              objects: {
                rental_order_id: returning?.id ?? null,
                buy_name : params?.fullname ?? null,
                buy_phone : params?.phone ?? null,
                buy_preferred_date : params?.apointment ?? null,
                buy_car_for_sell_id : params?.car_code ?? null,
                created_at: moment.tz(new Date(), this.time_zone_local),
                updated_at: moment.tz(new Date(), this.time_zone_local),
                updated_by: this.$store.getters.user,
                created_by: this.$store.getters.user,
                active: true,
                deleted : false,
                buy_email : params?.email ?? null,
              },
            }
          });
              this.redirectEdit();
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
            this.$commonFuction.is_loading(false);
        });
      } else {
        if (params.rental_order.booking_status === 'Booking' || params.rental_order.booking_status == 1) {
          params.rental_order.booking_status = 'BOOKING_BUY';
        } else if (params.rental_order.booking_status === 'Pending' || params.rental_order.booking_status == 2) {
          params.rental_order.booking_status = 'PENDING_BUY';
        } else if (params.rental_order.booking_status === 'Sold' || params.rental_order.booking_status == 3) {
          params.rental_order.booking_status = 'SOLD_BUY';
        } else if (params.rental_order.booking_status === 'Cancel' || params.rental_order.booking_status == 4) {
          params.rental_order.booking_status = 'CANCEL_BUY';
        }
        var object = {};
        object.is_edit_admin = true;
        if (params.rental_order.booking_status === 'SOLD_BUY') {
          object.car_status = 'SOLD_OUT_SELL';
          await this.$apollo.mutate({
            mutation: DataServices.updateData('car_for_sell'),
            variables: {
              'data_update': {
                'status': 'SOLD_OUT_SELL'
              },
              'where_key': {
                'id': { '_eq': params.car_for_sell.id }
              }
            }
          });
          
        }
        object = {
          ...object,
          booking_status: params?.rental_order?.booking_status,
          updated_at: moment.tz(new Date(), this.time_zone_local),
          updated_by: this.$store.getters.user,
          hide_rate: params?.rental_order?.hide_rate ?? true,
          note: params?.note ?? null,
        }

        await this.$apollo.mutate({
          mutation: DataServices.updateData('rental_order'),
          variables: {
            'data_update': object,
            'where_key': {
              'id': { '_eq': params.rental_order_id }
            }
          }
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            var returning = res.data[Object.keys(res.data)].returning[0];
            await this.$apollo.mutate({
              mutation: DataServices.updateData('rental_order_buy'),
              variables: {
                'data_update': {
                    rental_order_id: returning?.id ?? null,
                    buy_name: params?.fullname ?? null,
                    buy_phone: params?.phone ?? null,
                    buy_preferred_date: params?.apointment ?? null,
                    buy_car_for_sell_id: params?.car_for_sell?.id ?? null,
                    updated_at: moment.tz(new Date(), this.time_zone_local),
                    created_at: moment.tz(new Date(), this.time_zone_local),
                    updated_by: this.$store.getters.user,
                    active: params?.active ?? true,
                    buy_email: params?.email ?? null,
                },
                'where_key': {
                  'id': { '_eq': params.id }
                }
              }
            });
            if(params?.rental_order?.booking_status == 'CANCEL_BUY' && params?.rental_order?.booking_status != params.booking_status_root){
        var list_user = [params?.rental_order?.uid];
            var params_noti ={
                title:"",
                content:"",
                short_content:`[#${params?.rental_order?.code}] Your visit has been cancelled. `,
                short_content_noti:`[#${params?.rental_order?.code}] Your visit has been cancelled. `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
                uid:null,
                multi_uid:list_user,
                object_id:params.rental_order_id,
                is_admin:false,
                key_noti:3,//
              }
               await this.$CoreService.sendNoti(params_noti);
            }


            if (params?.rental_order?.booking_status == 'SOLD_BUY' && params?.rental_order?.booking_status != params.booking_status_root && !params.redeem) {
              var BUY_A_CAR_CUMULATIVE_SPENDING = await this.$CoreService.getSetting("BUY_A_CAR_CUMULATIVE_SPENDING");
              var BUY_A_CAR_CUMULATIVE_SPENDING_VALUE = !this.$commonFuction.isEmpty(BUY_A_CAR_CUMULATIVE_SPENDING.value) ? parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING.value) : 0;
              var orderAmount = parseFloat(params?.order_amount.replace(/[^0-9.-]+/g, ''));

              
              var proportion_reward = parseInt(parseFloat(orderAmount) / parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING_VALUE));
              console.log("order_amount_____", orderAmount)
              console.log('BUY_A_CAR_CUMULATIVE_SPENDING_VALUE______',BUY_A_CAR_CUMULATIVE_SPENDING_VALUE);
              console.log("proportion_rewardproportion_reward:", proportion_reward);
              
              var POINTS_REWARD_BUY = await this.$CoreService.getSetting("POINTS_REWARD_BUY");
              var POINTS_REWARD_BUY_VALUE = !this.$commonFuction.isEmpty(POINTS_REWARD_BUY.value) ? parseFloat(POINTS_REWARD_BUY.value) : 0;
              var point_value = proportion_reward * POINTS_REWARD_BUY_VALUE;
              console.log('point_valuepoint_value',point_value);
              if(point_value>0){
              var params_change_point = {
                uid: params?.rental_order?.uid,
                description: `Reward - Completed purchase a car #${params?.rental_order?.code} `,
                amount: parseFloat(point_value),
                updated_by: params?.rental_order?.uid,
                created_by: params?.rental_order?.uid,
                type: '2',
                object_id: params.rental_order_id,
                status: 'ST002'
              }
              console.log('params_change_pointparams_change_point',params_change_point);
              
              console.log("params?.rental_order", params?.rental_order);
              await this.$CoreService.changePoint(params_change_point);
               var params_noti_point ={
                title:"",
                content:"",
                short_content:`Congratulations on your new car! You've earned ${parseFloat(point_value)} points for your purchase.`,
                short_content_noti:`Congratulations on your new car! You've earned ${parseFloat(point_value)} points for your purchase.`,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.POINT_HISTORY,
                uid:null,
                multi_uid:list_user,
               // object_id:params.rental_order_id,
                is_admin:false,
                key_noti:1,//
              }
               await this.$CoreService.sendNoti(params_noti_point);
              }


              var list_user1 = [params?.rental_order?.uid];
              var params_noti1 = {
                title: "",
                content: "",
                short_content: `[#${params?.rental_order?.code}] Hey there! Congrats on your new car! We hope you love it. Don't forget to leave us a review and let us know how your experience was. `,
                short_content_noti: `[#${params?.rental_order?.code}] Hey there! Congrats on your new car! We hope you love it. Don't forget to leave us a review and let us know how your experience was. `,
                type: null,
                action_key: this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
                uid: null,
                multi_uid: list_user1,
                object_id: params.rental_order_id,
                is_admin: false,
                key_noti: 3,//
              }
              await this.$CoreService.sendNoti(params_noti1);

              // call api khi sold buy

              var data_ref_history = {
                order_id: params?.rental_order_id,
                user_id: params?.rental_order?.uid,
                ref_uid: params?.ref_uid,
                order_amount: orderAmount,
              }
              console.log("data_ref_historydata_ref_history", data_ref_history);

              const headers = { "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()), };

              if (data_ref_history.ref_uid != null && data_ref_history.ref_uid != '') {
                {
                  
                  var data = await ApiRepository.post('/api_admin/order/add_ref_history_buy', data_ref_history, { headers });
                  console.log("data_ref_history", data);
                  
                }
              }


            }



            this.redirectEdit();
          }
        }).catch(async error => {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-visit_list'};
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      //reload lại trang để update số bagde
      window.location.href = router_back.path;

      // console.log('router_back',router_back)
      // that.$commonFuction.is_loading(false);
      // if(that.mode == 'add'){
      //   that.$router.push(router_back);
      // }else{
      //   if (!that.$commonFuction.isEmpty(router_back)){
      //     // that.page_transaction = ""+that.page_transaction
      //     router_back.query = { page_transaction: that.page_transaction.toString() };
      //   }
      //   that.$router.push(router_back);
      // }
      
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('rental_order_buy'),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:",data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px;
  /* margin-bottom: 16px; */
  padding-bottom: 10px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 150px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 10px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.manager-title-row{
  border-bottom: 1px solid #EEEEEE;
}
.p-toolbar-group-right {
  flex-basis: 30%;
}
.p-button-warning.p-button {
  margin: 0 10px;
}
</style>